// 5s: one tick costs 2 Spotify calls/DJ; faster risks the dev-mode quota (429), slower blurs track changes.
export const PLAYBACK_POLL_INTERVAL_MS = 5000;
// 3x poll interval: slack for one jittered refetch, short enough to stop polling seconds after a room empties.
export const PARTY_DEMAND_TIMEOUT_MS = PLAYBACK_POLL_INTERVAL_MS * 3;
// Repaint only, not a request — advances the on-screen counter between PLAYBACK_POLL_INTERVAL_MS polls.
export const LIVE_TICK_MS = 1000;
/**
 * How long after a server-side Spotify sample lands the clients are told to
 * come back for it. The server does not answer "poll every N seconds" — it
 * answers "ask me again at this moment", aimed just past its own next upstream
 * read, so a client's request finds a sample that has already arrived rather
 * than one still in flight.
 */
export const POLL_SYNC_LEAD_MS = 500;
/**
 * How fast a DJ console re-reads its own channel. Faster than
 * `PLAYBACK_POLL_INTERVAL_MS` and deliberately so: crowd wants arrive from
 * other people's devices and cost nothing upstream to re-read, where the
 * Spotify half of the same response is capped by the shared poll either way.
 * It is a ceiling on the server's advice, not a second clock — a console still
 * lands just after a Spotify sample whenever one is due sooner than this.
 */
export const DJ_CONSOLE_POLL_INTERVAL_MS = 1000;
/** How often the freshness cue repaints. Nothing is fetched on this clock. */
export const POLL_CUE_TICK_MS = 100;
/**
 * The shortest the freshness cue's own cycle may be, however fast the surface
 * behind it polls. A DJ console re-reads its channel every
 * `DJ_CONSOLE_POLL_INTERVAL_MS` for the crowd wants, and a cue that restarted
 * on each of those would strobe at a DJ all night — worst of all with nothing
 * playing, where the second-by-second answers are identical. So arrivals inside
 * a cycle keep it alive without resetting it, and the cue runs at the cadence
 * the data behind it can actually change on.
 */
export const POLL_CUE_MIN_CYCLE_MS = PLAYBACK_POLL_INTERVAL_MS;
/** How many intervals a fetch may go missing before the cue calls the data stale. */
export const POLL_CUE_STALE_INTERVALS = 2.5;
/**
 * How long a take stays in `DjView.recentlyTaken`. Long enough that a console
 * polling on `DJ_CONSOLE_POLL_INTERVAL_MS` cannot miss one between reads, short
 * enough that the notice is news rather than a log.
 */
export const TAKEN_NOTICE_WINDOW_MS = 20_000;
/**
 * How long a search sits untouched before it clears itself and the panel goes
 * back to its default. Typing, scrolling the results and sending a track all
 * count as touching it. Both surfaces share the number because both are borrowed
 * devices: a phone handed round a room and a console the DJ steps away from.
 */
export const SEARCH_IDLE_RESET_MS = 30_000;
//# sourceMappingURL=config.js.map